import { GenericFiltrationContract } from "projects/shared/models/GenericFiltrationContract";

export class GameFiltrationDto extends GenericFiltrationContract{
    
    NodeId: number;   
    Level: string;
    ContainsStringValue: string;    

    constructor(parentId=-1, Level="", ContainsStringValue="", imageSize = "") {
        super(parentId, 1, 8, imageSize);
        this.NodeId = parentId;
        this.Level = Level;
        this.ContainsStringValue = ContainsStringValue;
    }


}